export default __webpack_public_path__ + "static/bentoImg5-c0c7e88cdb8f92e668079833f7680ae0.webp";